export default __webpack_public_path__ + "static/media/046-lemur.2a429cd3.svg";